import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { API_BASE_URL } from 'enwyse-widgets';
import { environment } from '../environments/environment';

import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { provideStore } from '@ngxs/store';
import { routes } from './app.routes';
import { ApplicationState } from './state/application-state';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from './config/translate-config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({
      anchorScrolling: 'enabled'
    })),
    provideHttpClient(withFetch()),
    provideStore([ApplicationState], withNgxsReduxDevtoolsPlugin()),
    provideTranslateService({
      defaultLanguage: 'nl',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory, 
        deps: [HttpClient]
      }
    }),
    provideCharts(withDefaultRegisterables()),
    provideIonicAngular({}),
    { provide: API_BASE_URL, useValue: environment.enwyseApiUrl.replace(/\/api\/?$/, '') },
  ],
};
